import * as React from "react";
import { Route } from 'react-router-dom';
import GQLPlayground from './pages/GQLPlayground';

export default [
  <Route exact path="/query" component={GQLPlayground} />,
];
